<div class="card_body cbody" >
    <div class="canvas_cont" >
        <!-- <div #captureContainer2 style="display: inline-block; padding: 30px;">
          <canvas #qrCodeCanvas2></canvas>
          <div style=" margin-top: 10px;">
              <h4>HGS76JHH
              </h4>
          </div>
        </div> -->
          
      </div>
      <!-- <div class="download_btn">
        <button mat-raised-button color="accent" (click)="downloadQR2()">Download</button>
      </div> -->
  </div>